module.exports = __webpack_public_path__ + "static/img/qualifications_icon_06.c0b07db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/qualifications_icon_06.png
// module id = AlGZ
// module chunks = 3